import { axios } from '@/utils/request'

// 获取商品列表
export function getGoodsList(params) {
  return axios({
    url: `/goods`,
    method: 'get',
    params
  })
}

// 查看商品信息
export function getGoods(goods_id) {
  return axios({
    url: `/goods/${goods_id}`,
    method: 'get'
  })
}

// 增加/编辑商品
export function editGoods(params) {
  return axios({
    url: '/goods/save',
    method: 'post',
    data: params
  })
}

// 修改商品
export function updateGoods(goods_id, params) {
  return axios({
    url: `/goods/${goods_id}`,
    method: 'put',
    data: params
  })
}

// 删除商品
export function deleteGoods(goods_id) {
  return axios({
    url: `/goods/${goods_id}`,
    method: 'delete'
  })
}
//导出商品库存异动个记录
export function exportGoodsRecord(params){
  return axios({
    url: 'url',
    method: 'get',
    params: params
  })
}
// 查询商品库存信息
export function queryGoodsStock(params){
  return axios({
    url: `/goods/stock/${params.goods_id}/${params.branch_id}`,
    method: 'get',
    params: params
  })
}
//查询库存信息
export function queryStock(stock_id){
  return axios({
    baseURL:"/api/wx",
    url: `/stock/${stock_id}`,
    method: 'get',
  })
}
//根据门店和69码查询库存信息
export function queryStockBy69Code(branch_id,barcode_69){
  return axios({
    baseURL:"/api/wx",
    url: `/stock/${branch_id}/${barcode_69}`,
    method: 'get',
  })
}

//设置商品是否精选
export function setGoodsFeatured(params){
  return axios({
    url: `/goods/featured`,
    method: 'post',
    data:params
  })
}